export default __webpack_public_path__ + "static/media/avatar_alina_manu.32c39d7a.jpeg";